import GooglePlayBadge from 'assets/google-play-store-badge.svg';
import AppleStoreBadge from 'assets/apple-app-store-badge.svg';
import { useIntl } from '@leagueplatform/locales';
import { EVENT_NAME, trackAnalyticsEvent } from '@leagueplatform/analytics';
import { EXTERNAL_LINKS } from 'common/links';
import {
  AssetLinkProps,
  FooterLinkProps,
} from '@leagueplatform/solutions-foundation';
import { useExternalLinks } from 'hooks/use-external-links/use-external-links.hook';
import { usePatientPortalContext } from 'contexts/patient-portal-provider.context';
import { PATIENT_PORTAL_SYSTEM_IDS } from 'types/patient-portal-system.types';

export const useAppFooterLinks = () => {
  const { formatMessage } = useIntl();
  const { systemId } = usePatientPortalContext();
  const externalLinks = useExternalLinks();

  const isMyhealth = systemId === PATIENT_PORTAL_SYSTEM_IDS.MY_HEALTH;

  const footerLinks: FooterLinkProps[] = [
    ...(externalLinks.PRIVACY
      ? [
          {
            text: formatMessage({ id: 'STR_COLLECTION_NOTICE' }),
            url: externalLinks.PRIVACY,
            onClick: () => {
              trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
                product_area: 'foundation',
                sub_product_area: 'home screen',
                screen_name: 'home screen',
                detail: 'navigate to privacy policy',
                brand: [systemId],
              });
            },
            linkProps: {
              indicator: undefined,
              target: '_blank',
              rel: 'noopener noreferrer',
            },
          },
        ]
      : []),
    ...(!isMyhealth && externalLinks.TERMS
      ? [
          {
            text: formatMessage({ id: 'STR_TERMS_OF_SERVICE' }),
            url: externalLinks.TERMS,
            onClick: () => {
              trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
                product_area: 'foundation',
                sub_product_area: 'home screen',
                screen_name: 'home screen',
                detail: 'navigate to terms of service',
                brand: [systemId],
              });
            },
            linkProps: {
              indicator: undefined,
              target: '_blank',
              rel: 'noopener noreferrer',
            },
          },
        ]
      : []),
  ];

  const appDownloadLinks: AssetLinkProps[] = [
    {
      src: AppleStoreBadge,
      url: EXTERNAL_LINKS.APPLE_STORE_APP,
      alt: formatMessage({ id: 'STR_DOWNLOAD_APP_STORE' }),
      linkProps: {
        onClick: () => {
          trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
            product_area: 'foundation',
            sub_product_area: 'home screen',
            screen_name: 'home screen',
            detail: 'navigate to download on app store',
            brand: [systemId],
          });
        },
      },
    },
    {
      src: GooglePlayBadge,
      url: EXTERNAL_LINKS.GOOGLE_PLAY_STORE_APP,
      alt: formatMessage({ id: 'STR_DOWNLOAD_GOOGLE_PLAY' }),
      linkProps: {
        onClick: () => {
          trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
            product_area: 'foundation',
            sub_product_area: 'home screen',
            screen_name: 'home screen',
            detail: 'navigate to download on google play store',
            brand: [systemId],
          });
        },
      },
    },
  ];

  return {
    footerLinks,
    appDownloadLinks,
  };
};
